<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>
export default {
  created() {

  },
  methods: {
  }
}
</script>

<style>

</style>
